// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ykFrwW4rYMlucB72pKJA {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 1;

    & > div {
        box-shadow: none;
    }
}

.QaNhli0LVTWUnEur7Ic2 {
    height: 100%;
    margin-bottom: 1.5rem;
    text-align: center;
}

.EqGw2oFuPfOTT1ppGCXg {
    height: 100%;
    justify-content: center;
    border: none;
    border-radius: 0;
    padding: 0;
    margin-bottom: 0;
}

img {
    max-width: 100%;
    height: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/QrCode/QrCode.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,UAAU;;IAEV;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB","sourcesContent":[".card-container {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    z-index: 1;\n\n    & > div {\n        box-shadow: none;\n    }\n}\n\n.code-container {\n    height: 100%;\n    margin-bottom: 1.5rem;\n    text-align: center;\n}\n\n.code-container-inner {\n    height: 100%;\n    justify-content: center;\n    border: none;\n    border-radius: 0;\n    padding: 0;\n    margin-bottom: 0;\n}\n\nimg {\n    max-width: 100%;\n    height: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardContainer": `ykFrwW4rYMlucB72pKJA`,
	"codeContainer": `QaNhli0LVTWUnEur7Ic2`,
	"codeContainerInner": `EqGw2oFuPfOTT1ppGCXg`
};
module.exports = ___CSS_LOADER_EXPORT___;
